import { Moon, Sun, Bell } from "lucide-react";
import styles from "./TopHeader.module.css";

const HeaderActions = ({
  theme,
  onToggleTheme,
  authUser,
  onOpenProfile,
  notificationCount = 3,
}) => {
  return (
    <div className={styles.rightGroup}>
      <button
        type="button"
        onClick={onToggleTheme}
        className={styles.iconButton}
        aria-label="Toggle theme"
        title={theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}
      >
        {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
      </button>

      <button
        type="button"
        className={styles.iconButton}
        aria-label="Notifications"
        title="Notifications"
      >
        <Bell size={18} />
        {notificationCount > 0 && (
          <span className={styles.notificationBadge}>{notificationCount}</span>
        )}
      </button>

      <button
        type="button"
        onClick={onOpenProfile}
        className={styles.profileAvatarBtn}
        aria-label="User Profile"
        title={authUser?.full_name || "Profile"}
      >
        <img
          src={
            authUser?.profile_picture ||
            authUser?.photo_url ||
            "https://images.unsplash.com/photo-1544723795-3fb6469f5b39"
          }
          alt={authUser?.full_name || "User"}
          className={styles.profileImg}
        />
      </button>
    </div>
  );
};

export default HeaderActions;
